import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { CustomField } from "components/sync/hooks/useFetchCustomFields";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/data-input/field`;

export interface UpdateFieldRequest {
  field: string;
  scenarioId: string;
  customField: CustomField | null;
}

export interface FieldResponse {
  field: string;
  name: string;
  sync_field: CustomField | null;
}

export interface UpdateFieldResponse {
  fields: FieldResponse[];
}

const updateField = async (request: UpdateFieldRequest): Promise<UpdateFieldResponse> => {
  const response = await axios.put<UpdateFieldResponse>(API_URL, {
    field: request.field,
    scenarioId: request.scenarioId,
    syncField: request.customField
  });

  return response.data;
};

export const useUpdateField = () => {
  const queryClient = useQueryClient();
  return useMutation<UpdateFieldResponse, AxiosError, UpdateFieldRequest>(updateField, {
    onSuccess: () => {
      queryClient.invalidateQueries(["scenarioFields"]);
    }
  });
};
